import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    container: {
      position: 'relative',
      '& .MUIRichTextEditor-placeHolder': {
        fontSize: 14,
      },
    },
    helpText: {
      position: 'absolute',
      bottom: 24,
      left: 12,
      color: palette.red,
    },
  });
